/* eslint-disable max-lines-per-function */
import isArray from 'lodash/isArray'
// import { useState } from 'react'
import Accordion from '@/stories/components/Common/FormComponents/Accordion'
import Checkbox from '@/stories/components/Common/FormComponents/Checkbox'
// import MultiRangeSlider from '@/stories/components/Common/FormComponents/MultiRangeSlider'
import { FilterList } from '@/components/Stocks/types/TCategory'

interface INewItem {
  key: string
  value: string
}

interface IStockFilters {
  className: string
  accordianMap: FilterList[]
  onFilterUpdate: (payload) => void
  onReset: () => void
  forMobile?: boolean
  filters?: {
    sectors?: INewItem[]
    day?: INewItem[]
    mCap?: INewItem[]
  }
}

const StockFilters = ({
  className,
  onFilterUpdate,
  onReset = () => {},
  forMobile = false,
  accordianMap = [],
  filters = {},
}: IStockFilters) => {
  // const [min, setMin] = useState(0)
  // const [max, setMax] = useState(1000)
  return (
    <div className={className}>
      <div className=" flex justify-between border-b px-1 py-3 text-sm leading-4">
        <div>Filter</div>
        <div
          className="cursor-pointer  text-brand-blue-azureRadiance lg:block"
          onClick={onReset}
        >
          Reset Filter
        </div>
      </div>
      <div className="border-x">
        {accordianMap.map(
          ({ label: accKey, value: accValue, filters: items, type = '' }) => (
            <Accordion
              key={accValue}
              label={accKey}
              openAccordion={!forMobile}
              showSelectedDot={
                isArray(filters[accValue])
                  ? !!filters[accValue].length
                  : !!filters[accValue]
              }
            >
              <form
                name="mf_desktop_filters_form"
                className="my-2 max-h-[19rem] overflow-x-auto"
                onClick={e => {
                  e.stopPropagation()
                }}
              >
                {items.map(({ label: key, value }) => (
                  <div className="my-3" key={value}>
                    <Checkbox
                      name={key}
                      label={key}
                      inputClassName="mx-2 rounded h-4 w-4"
                      labelClassName="text-sm text-brand-black"
                      value={value}
                      checked={
                        isArray(filters[accValue])
                          ? !!filters[accValue]?.includes(value)
                          : filters[accValue] === value
                      }
                      onClickCheckbox={value => {
                        onFilterUpdate({
                          type,
                          value,
                          key,
                          selectionKey: accValue,
                        })
                      }}
                      isValueToBeSent
                    />
                  </div>
                ))}{' '}
                {/* {accValue === 'price' && (
                  <div className="mb-4 pr-6 py-2">
                    <div className="text-brand-black text-sm pb-3">
                      {`₹${min} - ₹${max}`}
                    </div>
                    <div className=" pl-2">
                      <MultiRangeSlider
                        min={0}
                        max={50000}
                        step={100}
                        onChange={data => {
                          setMin(data.min)
                          setMax(data.max)
                          onFilterUpdate({
                            type,
                            value: `${data.min}-${data.max}`,
                            key: '',
                            selectionKey: accValue,
                          })
                        }}
                      />
                    </div>
                  </div>
                )} */}
              </form>
            </Accordion>
          ),
        )}
      </div>
    </div>
  )
}

export default StockFilters
